<div
  class="flex w-full flex-col rounded-xl border px-4 py-3 select-none"
  [style.box-shadow]="focused() ? 'var(--color-brand-shadow) 0px 0px 0px 4px' : 'none'"
  [class.border-main-200]="focused()"
>
  <div class="flex shrink-0 items-center justify-between border-b pb-3">
    <ng-content select="[previewHeader]" />
  </div>

  <div class="flex flex-1 flex-col gap-3 pb-3">
    @if (creativeType() !== SbCreativeType.video) {
      <div class="pt-3">
        <app-assets-preview [assets]="assets()" />
      </div>
    } @else {
      <div></div>
    }
    <div class="flex flex-1 gap-3">
      @if (creativeType() === SbCreativeType.video || creativeType() === SbCreativeType.brandVideo) {
        <app-video-preview [videoUrl]="assets()?.videoAssetId" />
        @if (creativeType() === SbCreativeType.video) {
          <app-video-asin-preview [asin]="asins()?.asin1" />
        }
      }
      @if (creativeType() !== SbCreativeType.video) {
        <app-asin-items-preview [asins]="asins()" [showRating]="creativeType() !== SbCreativeType.storeSpotlight" />
      }
    </div>
  </div>

  <ng-content select="[previewFooter]" />
</div>
